<script setup lang="ts">
import { Planungsgeschaeft } from '@/models/Planungsgeschaeft';
import { formatDayjsIf } from '@/helpers/tools';

const props = defineProps<{
    geschaeft: Planungsgeschaeft;
}>();
</script>

<template>
    <div class="stammdaten ktg-inner-box-padding">
        <div class="entry">
            <div class="ktg-eyebrow">{{ $t('eplan_nr') }}</div>
            <div class="value">{{ props.geschaeft.id || '-' }}</div>
        </div>
        <div class="entry">
            <div class="ktg-eyebrow">{{ $t('pg_nummer_kanton') }}</div>
            <div class="value">{{ props.geschaeft.boa_bgnumber || '-' }}</div>
        </div>
        <div class="entry">
            <div class="ktg-eyebrow">{{ $t('gemeinde') }}</div>
            <div class="value">{{ props.geschaeft.stelle || '-' }}</div>
        </div>
        <div class="entry">
            <div class="ktg-eyebrow">{{ $t('geschaeftsart') }}</div>
            <div class="value">{{ props.geschaeft.application_type_bezeichnung || '-' }}</div>
        </div>
        <div class="entry">
            <div class="ktg-eyebrow">{{ $t('status') }}</div>
            <div class="value">{{ props.geschaeft.aktueller_status || '-' }}</div>
        </div>
        <div class="entry">
            <div class="ktg-eyebrow">{{ $t('frist_kanton') }}</div>
            <div
                class="value"
                v-html="
                    props.geschaeft.estimated_end_date_kanton
                        ? formatDayjsIf(props.geschaeft.estimated_end_date_kanton, 'DD.MM.YYYY')
                        : '-'
                "
            ></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.stammdaten {
    padding-top: 1.5em;
    padding-bottom: 1.5em;
    background-color: var(--ktg-color-brand2-01);
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1em;
    .entry {
        .value {
            font-size: 0.875rem;
        }
    }
}
</style>
